<template>
	<Dialog
		:dialogVisible="visible"
		:title="'No Account Found'"
		:message="`We're sorry, but there is no LiveSwitch account associated with this email.  Please try logging in with different credentials, creating a free trial, or contact the organization administrator for your organization.  You can also reach the LiveSwitch team at ${supportEmail}, and we'd be happy to assist.`"
		:agreeText="'Start a Free Trial'"
		:cancelText="'Try a Different Email'"
		:persistentDialog="true"
		:customOutsideClickFunction="ignoreOutsideClick"
		@agree="redirectToTrialPage"
		@cancel="logout">
	</Dialog>
</template>

<script>
	import Dialog from "./Dialog.vue";
	export default {
		name: "NoAccount",
		components: {
			Dialog,
		},
		data() {
			return {
				visible: false,
				supportEmail: window.env.VITE_SUPPORT_EMAIL,
				trialpageUrl: window.env.VITE_TRIAL_PAGE_URL,
			};
		},
		methods: {
			open() {
				this.visible = true;
			},
			logout() {
				this.visible = false;
				this.$auth.logout({
					returnTo: window.location.protocol + "//" + window.location.host + "/logout",
				});
			},
			redirectToTrialPage() {
				this.visible = false;
				window.location.href = this.trialpageUrl;
			},
			ignoreOutsideClick() {
				// Do nothing on outside click
			},
		},
	};
</script>
